import Image, { type ImageProps } from 'next/image';

import { clc } from '@/legacy/components/base/utils';

import styles from '@/legacy/components/img/Img.module.scss';

type ImageStyleProps = {
	width?: string | number;
	height?: string | number;
	frameClass?: string;
	children?: React.ReactNode;
	alt?: string;
};

const Img = ({
	src,
	alt,
	frameClass,
	className,
	width,
	height,
	style,
	children,
	...props
}: ImageStyleProps & Omit<ImageProps, keyof ImageStyleProps>) => {
	return (
		<div className={clc('center', 'shrink', frameClass)} style={{ ...style, height, width }}>
			<Image
				{...props}
				alt={alt ? alt : 'image'}
				className={clc(styles.img, className)}
				fill
				// style={{ objectFit: 'cover' }}
				src={src}
			/>
			{children}
		</div>
	);
};

export default Img;
